import { apiClient } from "@/api/api-client.ts";
import type { Pagination } from "@/api/base-service.ts";
import type { CaseEvidence } from "../../types/evidence";

const caseEvidenceCategoryService = {
	listEvidenceCategoryByCaseId: async (id?: string, params = {}) => {
		const response = await apiClient.get<{ data: CaseEvidence[]; meta: Pagination }>("evidence-category-by-case-id", { params });
		return response.data;
	},
	listEvidenceCategoryByParties: async (id?: string, params = {}) => {
		const response = await apiClient.get<{ data: CaseEvidence[]; meta: Pagination }>("all-evidence-category-by-parties", { params });
		return response.data;
	},
	listEvidenceCategoryByType: async (id?: string, params = {}) => {
		const response = await apiClient.get<{ data: CaseEvidence[]; meta: Pagination }>("all-evidence-category-by-type", { params });
		return response.data;
	},
	listAllEvidenceWithCategories: async (id?: string, params = {}) => {
		const response = await apiClient.get<{ data: CaseEvidence[]; meta: Pagination }>("all-evidence-with-categories", { params });
		return response.data;
	},
	listAllEvidenceCategories: async (id?: string, params = {}) => {
		const response = await apiClient.get<{ data: string; meta: Pagination }>("all-categories", { params });
		return response.data;
	},
};

export default caseEvidenceCategoryService;
